<template>
    <div class="marriage-record-page">
        <div class="marriage-record-top-bar">
            <!-- 1. 标题部分 -->
            <div class="report-title-bar marriage-title-bar dsp-flex">
                <div class="report-title-side">
                    <span class="report-title-back" @click="clickBack"><i class="iconfont icon-xiangzuo"></i></span>
                </div>
                <div class="report-title-mid"><span>记录列表</span></div>
                <div class="report-title-side"></div>
            </div>
            <div class="marriage-record-search-box">
                <search-input 
                    v-bind:inputId="searchInputId"
                    v-bind:searchData="searchData"
                    v-bind:inputFunc="inputSearch">
                </search-input>
            </div>
        </div>
        <div class="marriage-record-list-box">
            <div class="marriage-record-list">
                <div v-if="!gotRecordData" class="layout-rl-note">正在加载数据...</div>
                <div v-else-if="searchListData.length == 0 && noRecordData" class="layout-rl-note">暂无记录数据</div>
                <div v-else>
                    <virtual-list id="MarriageRecordList" ref="vsl" class="marriage-record-list-list scroll-touch"
                        :data-key="'id'"
                        :data-sources="searchListData.length > 0 ? searchListData : recordListData"
                        :data-component="itemComponent"
                        :estimate-size="50"
                        :item-class="'list-item-fixed'" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SearchInput from '../../components/SearchInput.vue'
import MarriageRecordItem from '../../components/marriage/MarriageRecordItem.vue';
import { MIX, UTILS, UA } from '../../modules/utils';
import { CONFIG } from '../../modules/config';
export default {
    name: 'MarriageRecord',
    components: { SearchInput, MarriageRecordItem },
    computed: {
        searchData() {
            return this.$store.state.search.searchData;
        },
        gotRecordData() {
            return this.$store.state.marriage.gotRecordData;
        },
        noRecordData() {
            return this.$store.state.marriage.noRecordData;
        },
        recordListData() {
            return this.$store.state.marriage.recordListData;
        },
        searchListData() {
            return this.$store.state.marriage.searchListData;
        },
    },
    data() {
        return {
            UTILS: UTILS,
            searchInputId: 'marriageSearchInput',
            itemComponent: MarriageRecordItem,

        }
    },
    mounted() {
        setTimeout(() => {
            this.initDom();
            this.initData();
        }, 20);
    },
    methods: {
        initDom() {
            let winH = window.innerHeight;
            let topBarH = document.getElementsByClassName('marriage-record-top-bar')[0].offsetHeight;
            let listBox = document.getElementById('MarriageRecordList');
            if(listBox) {
                listBox.style.height = (winH - topBarH+20) + 'px';
            }
        },
        initData() {
            if(!this.gotRecordData) {
                this.$store.dispatch('marriage/initRecordList', {
                    sucCb: ()=> {
                        // 初始化完成
                        setTimeout(() => {
                            this.initDom();
                        }, 200);
                    }
                });
            }
        },
        clickBack() {
            this.$router.replace({ path: '/marriage' });
        },
        inputSearch(word) {
            if(word != ''){
                this.$store.dispatch('marriage/confirmSearchMarriage', word);
            }else{
                this.$store.state.marriage.searchListData = [];
            }
        },
    }
}
</script>